import { createWebHashHistory, createRouter } from 'vue-router';

import { refresh } from '@/plugins/helpers';
import store from '../store';

import Index from '../pages/Index.vue';
import Timetable from '../pages/Timetable.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Index,
  },
  {
    path: '/calendar/',
    name: 'Calendar',
    component: Timetable,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  mode: 'hash',
  routes,
});

router.beforeEach(
  async (to, from, next) => {
    const publicPages = ['/'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = store.getters.accessToken;
    let refreshStatus = null;

    if (store.getters.refreshToken) {
      refreshStatus = await refresh();
    }

    if ((authRequired && !loggedIn) || (refreshStatus && refreshStatus !== 200)) next('/');
    else if (to.path === '/' && loggedIn) next('/calendar/');
    next();
  },
);

export default router;
